module.exports = __webpack_public_path__ + "images/21f1f26b7ef60e74deeb8a582e5a46e19.svg";